import React from "react";
import { ButtonStyled } from "../../assets/styles/components/button";

const Button = ({ children, ...props }) => {
  return <ButtonStyled {...props}>{children}</ButtonStyled>;
};

export default Button;
